//import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import LayoutPublic from "./component/Layout/LayoutPublic";
import ApplicationForm from './page/ApplicationForm';
import Result from './page/Result';
import ScanCode from './page/RescanCode';

function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <BrowserRouter>
      <LayoutPublic>
        <Routes>
          <Route path='/' element={<ApplicationForm />} />
          <Route path='/Result' element={<Result />} />
          <Route path='*' element={<ScanCode />} />
        </Routes>
      </LayoutPublic>

    </BrowserRouter>
  );
}

export default App;
